import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameMeasurements";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//IMAGES
import Bar from "../../assets/Statistics/Images/Bar.png";
import BarBar from "../../assets/Statistics/Images/BarBar.png";
import Tally from "../../assets/Statistics/Images/Tally.png";
import TallyLine from "../../assets/Statistics/Images/TallyLine.png";
import TallyStrike from "../../assets/Statistics/Images/TallyStrike.png";
import Tally1 from "../../assets/Statistics/Images/Tally1.png";
import Tally2 from "../../assets/Statistics/Images/Tally2.png";
import Tally3 from "../../assets/Statistics/Images/Tally3.png";
import Tally4 from "../../assets/Statistics/Images/Tally4.png";
import Tally5 from "../../assets/Statistics/Images/Tally5.png";
import Pictograph from "../../assets/Statistics/Images/Pictograph.png";
import LineGraph from "../../assets/Statistics/Images/LineGraph.png";
import Line from "../../assets/Statistics/Images/Line.png";
import TimeTable from "../../assets/Statistics/Images/TimeTable.png";
//animals
import Elephant from "../../assets/Statistics/Images/Elephant.png";
import ElephantHalf from "../../assets/Statistics/Images/ElephantHalf.png";
import Giraffe from "../../assets/Statistics/Images/Giraffe.png";
import GiraffeHalf from "../../assets/Statistics/Images/GiraffeHalf.png";
import Lion from "../../assets/Statistics/Images/Lion.png";
import LionHalf from "../../assets/Statistics/Images/LionHalf.png";
import Zebra from "../../assets/Statistics/Images/Zebra.png";
import ZebraHalf from "../../assets/Statistics/Images/ZebraHalf.png";
//line graphs
import LineGraph1 from "../../assets/Statistics/Images/LineGraph1.png";
import LineGraph2 from "../../assets/Statistics/Images/LineGraph2.png";
import LineGraph3 from "../../assets/Statistics/Images/LineGraph3.png";
import LineGraph4 from "../../assets/Statistics/Images/LineGraph4.png";
//pie charts
import Pie1 from "../../assets/Statistics/Images/Pie1.png";
import Pie2 from "../../assets/Statistics/Images/Pie2.png";
import Pie3 from "../../assets/Statistics/Images/Pie3.png";
import Pie4 from "../../assets/Statistics/Images/Pie4.png";
import Pie5 from "../../assets/Statistics/Images/Pie5.png";
//number sequence
import Sequence from "../../assets/Statistics/Images/Sequence.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;
var qImage;

//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function RandomChar() {
  var result = '';
  var characters = 'abcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  result = characters.charAt(Math.floor(Math.random() * charactersLength));
  return result;
}

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function GenerateQuestion(q) {
  var key = q.question_key;
  let imageString;
  let questionAnswers = [];

  let correctAnswerImage = "";
  let correctAnswer = q.right_answer;
  let html = "";
  let questionString = q.question;

  if (q.topic_key == "Stat1") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0];
    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + Bar + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:79%'>" + "Zebras" + "</b>" +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:79%'>" + "Lions" + "</b>" +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:79%'>" + "Elephants" + "</b>" +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:79%'>" + "Giraffes" + "</b>";
    var rightPos = 76;
    var rightmodifier = -7;
    for (let i = 0; i < 11; i++) {
      html +=
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
      rightPos += rightmodifier;
    }
    //then have the 3 bars
    var toppos = 70;
    var topModifier = -21;
    var scaleModifier = 0.85;//0.85 per every 1
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      html +=
        //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
        '<img src="' + BarBar + '"' + "style='position:absolute ; right:69%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(orderNumbers[i + 1]) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
      toppos += topModifier;
    }
  }

  if (q.topic_key == "Stat2") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0];

    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }
    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //return matching value
    //this is different than the other one because the image has the labels in the wrong order!
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";
    //then have the tally amounts
    var rightPos = 57;
    var bigPosModifier = -22;
    for (let i = 1; i < orderNumbers.length; i++) {
      console.log(orderNumbers[i]);
      var amount = (ReturnMatchingValue(orderNumbers[i]));
      if (amount < 6) {
        html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
      } else {
        html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
      }

      rightPos += bigPosModifier;
    }
  }

  if (q.topic_key == "Stat3") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0];

    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }

    //return matching value
    //this is different than the other one because the image has the labels in the wrong order!
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";

    //then have the tally amounts
    var rightPos = 82;
    var bigPosModifier = -22.2;
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      console.log(orderNumbers[i]);
      var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
      html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

      rightPos += bigPosModifier;
    }
  }

  if (q.topic_key == "Stat4") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0];
    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnAnimal(input) {
      if (input == 0)
        return Zebra;
      if (input == 0.5)
        return ZebraHalf;
      if (input == 1)
        return Lion;
      if (input == 1.5)
        return LionHalf;
      if (input == 2)
        return Elephant;
      if (input == 2.5)
        return ElephantHalf;
      if (input == 3)
        return Giraffe;
      if (input == 3.5)
        return GiraffeHalf;


    }
    html = '<img src="' + Pictograph + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
      '<img src="' + Zebra + '"' + "style='position:absolute ; top:70%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Lion + '"' + "style='position:absolute ; top:50%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Elephant + '"' + "style='position:absolute ; top:30%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Giraffe + '"' + "style='position:absolute ; top:10%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + GiraffeHalf + '"' + "style='position:absolute ; top:40%; right:16%; transform: scale(1.5,1.5);  zIndex:-1'" + '></img>' +
      "<b style='font-size:30px ; color:#815B37FF ; position:absolute ; top:42%; right:8%;  zIndex:-1'> = 1 </b>"

    var rightPos = 76;
    var rightmodifier = -7;

    //then have the 3 bars
    var toppos = 71;
    var topModifier = -20.5;
    var scaleModifier = 0.85;//0.85 per every 1
    var rightPos = 69;
    var rightModifier = -10;
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      var amount = ReturnMatchingValue(orderNumbers[i + 1]);
      if (i == 1 || i == 2) {
        rightPos = 69;
      } else {
        rightPos = 72;
      }

      //spawn amount of animals equal to the number, if number is odd then end with a half
      amount = amount / 2;
      console.log(amount);

      for (let z = 0; z < amount; z++) {
        if (Number.isInteger(amount) == false && amount - 0.5 == z) {
          html += '<img src="' + ReturnAnimal(i + 0.5) + '"' + "style='position:absolute ; top:" + (toppos - 1) + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        }
        else {
          html += '<img src="' + ReturnAnimal(i) + '"' + "style='position:absolute ; top:" + toppos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        }

        rightPos += rightModifier;
      }

      //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
      //'<img src="' + BarBar + '"' + "style='position:absolute ; right:69%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(orderNumbers[i + 1]) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
      toppos += topModifier;
    }
  }

  if (q.topic_key == "Stat5") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0] * q.increments;
    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i] * q.increments,
        answerImage: ""
      });
    }
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnAnimal(input) {
      if (input == 0)
        return Zebra;
      if (input == 0.5)
        return ZebraHalf;
      if (input == 1)
        return Lion;
      if (input == 1.5)
        return LionHalf;
      if (input == 2)
        return Elephant;
      if (input == 2.5)
        return ElephantHalf;
      if (input == 3)
        return Giraffe;
      if (input == 3.5)
        return GiraffeHalf;


    }
    html = '<img src="' + Pictograph + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
      '<img src="' + Zebra + '"' + "style='position:absolute ; top:70%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Lion + '"' + "style='position:absolute ; top:50%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Elephant + '"' + "style='position:absolute ; top:30%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Giraffe + '"' + "style='position:absolute ; top:10%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + GiraffeHalf + '"' + "style='position:absolute ; top:40%; right:18%; transform: scale(1.5,1.5);  zIndex:-1'" + '></img>' +
      "<b style='font-size:30px ; color:#815B37FF ; position:absolute ; top:42%; right:8%;  zIndex:-1'>= " + q.increments + "</b>"

    var rightPos = 76;
    var rightmodifier = -7;

    //then have the 3 bars
    var toppos = 71;
    var topModifier = -20.5;
    var scaleModifier = 0.85;//0.85 per every 1
    var rightPos = 69;
    var rightModifier = -10;
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      var amount = ReturnMatchingValue(orderNumbers[i + 1]);
      if (i == 1 || i == 2) {
        rightPos = 69;
      } else {
        rightPos = 72;
      }

      //spawn amount of animals equal to the number, if number is odd then end with a half
      amount = amount / 2;
      console.log(amount);

      for (let z = 0; z < amount; z++) {
        if (Number.isInteger(amount) == false && amount - 0.5 == z) {
          html += '<img src="' + ReturnAnimal(i + 0.5) + '"' + "style='position:absolute ; top:" + (toppos - 1) + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        }
        else {
          html += '<img src="' + ReturnAnimal(i) + '"' + "style='position:absolute ; top:" + toppos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        }

        rightPos += rightModifier;
      }
      toppos += topModifier;
    }
  }

  if (q.topic_key == "Stat6") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }



    if (orderNumbers[0] == "Picto") {
      var sum = 0;
      for (let i = 0; i < answers.length; i++) {
        sum += (answers[i] * q.increments)
      }
      correctAnswer = sum;
    }
    else {
      var sum = 0;
      for (let i = 0; i < answers.length; i++) {
        sum += (answers[i])
      }
      correctAnswer = sum;
    }

    var answersUsed = [];
    answersUsed.push(correctAnswer);

    for (let i = 1; i < 4; i++) {
      var ans = GenerateUniqueRandom(1, 40, answersUsed)
      answersUsed.push(ans);
      questionAnswers.push({
        correct: false,
        value: ans,
        answerImage: ""
      });
    }


    //return matching value
    function ReturnMatchingValue(input) {
      input = input - 4;
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnAnimal(input) {
      if (input == 0)
        return Zebra;
      if (input == 0.5)
        return ZebraHalf;
      if (input == 1)
        return Lion;
      if (input == 1.5)
        return LionHalf;
      if (input == 2)
        return Elephant;
      if (input == 2.5)
        return ElephantHalf;
      if (input == 3)
        return Giraffe;
      if (input == 3.5)
        return GiraffeHalf;
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //THIS IS FOR PICTOGRAPH
    if (orderNumbers[0] == "Picto") {
      html = '<img src="' + Pictograph + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
        '<img src="' + Zebra + '"' + "style='position:absolute ; top:70%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Lion + '"' + "style='position:absolute ; top:50%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Elephant + '"' + "style='position:absolute ; top:30%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Giraffe + '"' + "style='position:absolute ; top:10%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + GiraffeHalf + '"' + "style='position:absolute ; top:40%; right:18%; transform: scale(1.5,1.5);  zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF ; position:absolute ; top:42%; right:8%;  zIndex:-1'>= " + q.increments + "</b>"

      var rightPos = 76;
      var rightmodifier = -7;

      //then have the 3 bars
      var toppos = 71;
      var topModifier = -20.5;
      var scaleModifier = 0.85;//0.85 per every 1
      var rightPos = 69;
      var rightModifier = -10;
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        var amount = ReturnMatchingValue(orderNumbers[i + 1]);
        if (i == 1 || i == 2) {
          rightPos = 69;
        } else {
          rightPos = 72;
        }

        //spawn amount of animals equal to the number, if number is odd then end with a half
        amount = amount / 2;
        console.log(amount);

        for (let z = 0; z < amount; z++) {
          if (Number.isInteger(amount) == false && amount - 0.5 == z) {
            html += '<img src="' + ReturnAnimal(i + 0.5) + '"' + "style='position:absolute ; top:" + (toppos - 1) + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
          }
          else {
            html += '<img src="' + ReturnAnimal(i) + '"' + "style='position:absolute ; top:" + toppos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
          }

          rightPos += rightModifier;
        }
        toppos += topModifier;
      }
    }
    //THIS IS FOR BAR GRAPH
    else if (orderNumbers[0] == "Bar") {
      html = '<img src="' + Bar + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:79%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:79%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:79%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:79%'>" + "Giraffes" + "</b>";
      var rightPos = 76;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:69%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(orderNumbers[i + 1]) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers[0] == "Tally") {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57;
      var bigPosModifier = -22;
      for (let i = 1; i < orderNumbers.length; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i]));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82;
      var bigPosModifier = -22.2;
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  //SUBTRACTION
  if (q.topic_key == "Stat7") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    var ansvalues = [];
    ansvalues.push(q.answer_5);
    ansvalues.push(q.answer_6);
    ansvalues.push(q.answer_7);
    ansvalues.push(q.answer_8);
    console.log(ansvalues);

    for (let i = 0; i < 4; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      console.log(genRange);
      answers.push(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])));
    }
    console.log(answers);

    var answerSplit = q.answer_1.split("|");
    if (answerSplit[1] == "6.5") {
      //lions minus zebraas
      correctAnswer = answers[1] - answers[0];
    } else if (answerSplit[1] == "7.8") {
      //elphants minus giraffes
      correctAnswer = answers[2] - answers[3];
    }

    var answersUsed = [];
    answersUsed.push(correctAnswer);

    for (let i = 1; i < 4; i++) {
      var ans = GenerateUniqueRandom(1, 10, answersUsed)
      answersUsed.push(ans);
      questionAnswers.push({
        correct: false,
        value: ans,
        answerImage: ""
      });
    }


    //return matching value
    function ReturnMatchingValue(input) {
      input = input - 4;
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnAnimal(input) {
      if (input == 0)
        return Zebra;
      if (input == 0.5)
        return ZebraHalf;
      if (input == 1)
        return Lion;
      if (input == 1.5)
        return LionHalf;
      if (input == 2)
        return Elephant;
      if (input == 2.5)
        return ElephantHalf;
      if (input == 3)
        return Giraffe;
      if (input == 3.5)
        return GiraffeHalf;
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //THIS IS FOR PICTOGRAPH
    if (orderNumbers[0] == "Picto") {
      html = '<img src="' + Pictograph + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
        '<img src="' + Zebra + '"' + "style='position:absolute ; top:70%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Lion + '"' + "style='position:absolute ; top:50%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Elephant + '"' + "style='position:absolute ; top:30%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Giraffe + '"' + "style='position:absolute ; top:10%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + GiraffeHalf + '"' + "style='position:absolute ; top:40%; right:18%; transform: scale(1.5,1.5);  zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF ; position:absolute ; top:42%; right:8%;  zIndex:-1'>= " + q.increments + "</b>"

      var rightPos = 76;
      var rightmodifier = -7;

      //then have the 3 bars
      var toppos = 71;
      var topModifier = -20.5;
      var scaleModifier = 0.85;//0.85 per every 1
      var rightPos = 69;
      var rightModifier = -10;
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        var amount = ReturnMatchingValue(orderNumbers[i + 1]);
        if (i == 1 || i == 2) {
          rightPos = 69;
        } else {
          rightPos = 72;
        }

        //spawn amount of animals equal to the number, if number is odd then end with a half
        amount = amount / 2;
        console.log(amount);

        for (let z = 0; z < amount; z++) {
          if (Number.isInteger(amount) == false && amount - 0.5 == z) {
            html += '<img src="' + ReturnAnimal(i + 0.5) + '"' + "style='position:absolute ; top:" + (toppos - 1) + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
          }
          else {
            html += '<img src="' + ReturnAnimal(i) + '"' + "style='position:absolute ; top:" + toppos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
          }

          rightPos += rightModifier;
        }
        toppos += topModifier;
      }
    }
    //THIS IS FOR BAR GRAPH
    else if (orderNumbers[0] == "Bar") {
      html = '<img src="' + Bar + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:79%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:79%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:79%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:79%'>" + "Giraffes" + "</b>";
      var rightPos = 76;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:69%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(orderNumbers[i + 1]) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers[0] == "Tally") {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57;
      var bigPosModifier = -22;
      for (let i = 1; i < orderNumbers.length; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i]));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82;
      var bigPosModifier = -22.2;
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  if (q.topic_key == "Stat8") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    answers.push(q.answer_1);
    answers.push(q.answer_2);
    answers.push(q.answer_3);
    answers.push(q.answer_4);

    correctAnswer = answers[0] + "m";

    questionAnswers.push({
      correct: false,
      value: answers[1] + "m",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[2] + "m",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[3] + "m",
      answerImage: ""
    });
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + LineGraph + '"' + "style='position:relative  ; right:0% ; zIndex:-1'" + '></img>';
  }

  if (q.topic_key == "Stat9") {
    //this is the order to which is correct
    var graphId = GenerateRandom(1, 4);
    var temps = [,];
    var miniTemp = [];

    if (graphId == 1) {
      miniTemp.push(0);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 2) {
      miniTemp.push(0);
      miniTemp.push(20);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(10);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 3) {
      miniTemp.push(0);
      miniTemp.push(10);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 4) {
      miniTemp.push(0);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(30);
      miniTemp.push(50);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }

    console.log(q);
    console.log(temps);
    if (q.answer_1 == "sum|5.9") {
      correctAnswer = temps[1][0] + temps[1][1];
    }
    if (q.answer_1 == "sum|6.10") {
      correctAnswer = temps[2][0] + temps[2][1];
    }
    if (q.answer_1 == "sum|7.11") {
      correctAnswer = temps[3][0] + temps[3][1];
    }
    if (q.answer_1 == "sum|8.12") {
      correctAnswer = temps[4][0] + temps[4][1];
    }

    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    var ansvalues = [];
    ansvalues.push(q.answer_5);
    ansvalues.push(q.answer_6);
    ansvalues.push(q.answer_7);
    ansvalues.push(q.answer_8);

    answers.push(correctAnswer);
    for (let i = 0; i < 4; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      answers.push(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])) * q.increments);
    }

    var noDupes;
    do{
      let noDupes = true;
      for(let i = 0; i < 4; i++){
        for(let j = 1; j < 4; j++){
          if(answers[i] == answers[j] && i != j){
            answers[j] += 10;
            noDupes = false;
          }
        }
      }
      
    }while(noDupes == false);


    correctAnswer += "°C"
    questionAnswers.push({
      correct: false,
      value: answers[1] + "°C",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[2] + "°C",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[3] + "°C",
      answerImage: ""
    });
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnLineGraph() {
      if (graphId == 1)
        return LineGraph1;
      if (graphId == 2)
        return LineGraph2;
      if (graphId == 3)
        return LineGraph3;
      if (graphId == 4)
        return LineGraph4;
    }

    html = '<img src="' + ReturnLineGraph() + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }

  if (q.topic_key == "Stat10") {
    //this is the order to which is correct
    var graphId = GenerateRandom(1, 4);
    var temps = [,];
    var miniTemp = [];

    if (graphId == 1) {
      miniTemp.push(0);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 2) {
      miniTemp.push(0);
      miniTemp.push(20);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(10);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 3) {
      miniTemp.push(0);
      miniTemp.push(10);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 4) {
      miniTemp.push(0);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(30);
      miniTemp.push(50);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }

    console.log(q);
    console.log(temps);
    if (q.answer_1 == "subtract|5.9") {
      console.log(Math.abs(5, 9));
      correctAnswer = Math.abs(temps[1][0] - temps[1][1]);
    }
    if (q.answer_1 == "subtract|6.10") {
      correctAnswer = Math.abs(temps[2][0] - temps[2][1]);
    }
    if (q.answer_1 == "subtract|7.11") {
      correctAnswer = Math.abs(temps[3][0] - temps[3][1]);
    }
    if (q.answer_1 == "subtract|8.12") {
      correctAnswer = Math.abs(temps[4][0] - temps[4][1]);
    }

    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    var ansvalues = [];
    ansvalues.push(q.answer_5);
    ansvalues.push(q.answer_6);
    ansvalues.push(q.answer_7);
    ansvalues.push(q.answer_8);

    answers.push(correctAnswer);
    for (let i = 0; i < 4; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      answers.push(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])) * q.increments);
    }
    var noDupes;
    do{
      noDupes = true;
      for(let i = 0; i < 4; i++){
        for(let j = 1; j < 4; j++){
          if(answers[i] == answers[j] && i != j){
            answers[j] += 10;
            noDupes = false;
          }
        }
      }
      
    }while(noDupes == false);



    correctAnswer += "°C"
    questionAnswers.push({
      correct: false,
      value: answers[1] + "°C",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[2] + "°C",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[3] + "°C",
      answerImage: ""
    });
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnLineGraph() {
      if (graphId == 1)
        return LineGraph1;
      if (graphId == 2)
        return LineGraph2;
      if (graphId == 3)
        return LineGraph3;
      if (graphId == 4)
        return LineGraph4;
    }

    html = '<img src="' + ReturnLineGraph() + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }


  if (q.topic_key == "Stat11") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");

    var answers = [];
    var ansvalues = [];
    ansvalues.push(q.answer_1);
    ansvalues.push(q.answer_2);
    ansvalues.push(q.answer_3);
    ansvalues.push(q.answer_4);
    console.log(ansvalues);

    function ConvertToTime(hours, minutes) {
      return hours + ":" + minutes;
    }

    ///tomorrow add the unique random of these above
    //randomise which order it is displayed in

    //sets random times for 4 of the fields
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      console.log(genRange);
      var hours = parseInt(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])));
      var minutes = "00";
      if (Math.random() > 0.5) {
        minutes = "30";
      }
      answers.push(ConvertToTime(hours, minutes));
    }
    //do it again for the other fields
    ansvalues = [];
    ansvalues.push(q.answer_5);
    ansvalues.push(q.answer_6);
    ansvalues.push(q.answer_7);
    ansvalues.push(q.answer_8);
    //random again
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      console.log(genRange);
      var hours = parseInt(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])));
      var minutes = "00";
      if (Math.random() > 0.5) {
        minutes = "30";
      }
      answers.push(ConvertToTime(hours, minutes));
    }
    //for answers teh id 0-3 is equal to 1-4 on the graph
    //4-7 is equal to 5 to 8 on the graph

    //the order it appears in is to do with the question

    correctAnswer = answers[0];

    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }


    //return matching value
    //this is different than the other one because the image has the labels in the wrong order!
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + TimeTable + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:40px ; color:#815B37FF; position:absolute ; top:8% ; right:29.5%'>" + "Zoo Schedule" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:32% ; right:61.5%'>" + "Arriving" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:32% ; right:43.5%'>" + "Feeding" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:32% ; right:25%'>" + "Cleaning" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:32% ; right:5.5%'>" + "Departing" + "</b>";
    console.log(q);
    var labels = q.horizontal_axis_2.split("/");

    function ReturnAnimalRight(animal) {
      if (animal == "Zebras") {
        return "81.5%"
      }
      if (animal == "Lions") {
        return "82.5%"
      }
      if (animal == "Elephants") {
        return "79%"
      }
      if (animal == "Girraffes") {
        return "79.5%";
      }
    }

    if (Math.random() > 0.5) {

      html += "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:46% ; right:" + ReturnAnimalRight(labels[0]) + "'>" + labels[0] + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:60% ; right:" + ReturnAnimalRight(labels[1]) + "'>" + labels[1] + "</b>";
      //then have the tally amounts
      var rightPos = 64.5;
      var bigPosModifier = -18.5;

      for (let i = 0; i < orderNumbers.length - 1; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:46%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }

      rightPos = 64.5;
      for (let i = 4; i < 8; i++) {
        console.log(orderNumbers[i]);
        var amount = answers[i];
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:60.5%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    } else {
      html += "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:46% ; right:" + ReturnAnimalRight(labels[1]) + "'>" + labels[1] + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:60% ; right:" + ReturnAnimalRight(labels[0]) + "'>" + labels[0] + "</b>";
      //then have the tally amounts
      var rightPos = 64.5;
      var bigPosModifier = -18.5;

      for (let i = 4; i < 8; i++) {
        console.log(orderNumbers[i]);
        var amount = answers[i];
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:46%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }

      rightPos = 64.5;

      for (let i = 0; i < orderNumbers.length - 1; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:60.5%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  if (q.topic_key == "Stat14") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var orderNumbers2 = q.type_of_chart_2.split("/");
    var answers = [];
    console.log(q);
    for (let i = 0; i < 8; i++) {
      answers.push(GenerateRandom(1, 10));
    }
    console.log(answers);

    var answerPlusID = [];
    for (let i = 0; i < 8; i++) {
      answerPlusID.push({
        number: answers[i],
        id: (5 + i)
      })
    }
    console.log(answerPlusID);
    var answerWanted = q.answer_1.split("|");
    answerWanted = answerWanted[1].split(".");
    console.log(answerWanted);

    var sum = 0;
    for (let i = 0; i < answerPlusID.length; i++) {
      //only add the appropriate ones
      if (answerPlusID[i].id == answerWanted[0] || answerPlusID[i].id == answerWanted[1])
        sum += (answerPlusID[i].number)
    }
    console.log("The sum equals " + sum);
    //this works
    correctAnswer = sum;


    var answersUsed = [];
    answersUsed.push(correctAnswer);

    //randomise incorrect answers
    for (let i = 1; i < 4; i++) {
      var ans = GenerateUniqueRandom(1, 20, answersUsed)
      answersUsed.push(ans);
      questionAnswers.push({
        correct: false,
        value: ans,
        answerImage: ""
      });
    }


    //return matching value
    //use id instead???
    function ReturnMatchingValue(id) {
      console.log(id);
      for (let i = 0; i < answerPlusID.length; i++) {
        if (answerPlusID[i].id == id) {
          console.log(id + " matches with " + answerPlusID[i].id + " with a number of " + answerPlusID[i].number)
          return answerPlusID[i].number;
        }
      }
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //THIS IS FOR BAR GRAPH
    if (orderNumbers[0] == "Bar") {
      html = '<img src="' + Bar + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:137%'>" + "Zoo" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:134%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:134%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:134%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:134%'>" + "Giraffes" + "</b>";
      var rightPos = 76 + 55;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 5; i < 9; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:124%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(i) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers[0] == "Tally") {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:100%'>" + "Zoo" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:131.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:110.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:83.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:63%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57 + 55;
      var bigPosModifier = -22;
      for (let i = 5; i < 9; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:100%'>" + "Zoo" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:131.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:110.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:83.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:63%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82 + 55;
      var bigPosModifier = -22.2;
      for (let i = 5; i < 9; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }

    //then make graph on the right using the other values

    //THIS IS FOR BAR GRAPH
    if (orderNumbers2[0] == "Bar") {
      html += '<img src="' + Bar + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:27%'>" + "Safari" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:27%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:27%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:24%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:27%'>" + "Giraffes" + "</b>";
      var rightPos = 76 - 55;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 9; i < 13; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:14%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(i) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers2[0] == "Tally") {
      html += '<img src="' + Tally + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:-13%'>" + "Safari" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:21.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:0.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-27.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-47%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57 - 55;
      var bigPosModifier = -22;
      for (let i = 9; i < 13; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html += '<img src="' + Tally + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:-13%'>" + "Safari" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:21.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:0.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-27.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-47%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82 - 55;
      var bigPosModifier = -22.2;
      for (let i = 9; i < 13; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  //SUBTRACTING MULTIPLE CHARTS
  if (q.topic_key == "Stat15") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var orderNumbers2 = q.type_of_chart_2.split("/");
    var numberRanges = [];
    numberRanges.push(q.answer_5.split("|")[1].split("."))
    numberRanges.push(q.answer_6.split("|")[1].split("."))
    numberRanges.push(q.answer_7.split("|")[1].split("."))
    numberRanges.push(q.answer_8.split("|")[1].split("."))
    numberRanges.push(q.answer_9.split("|")[1].split("."))
    numberRanges.push(q.answer_10.split("|")[1].split("."))
    numberRanges.push(q.answer_11.split("|")[1].split("."))
    numberRanges.push(q.answer_12.split("|")[1].split("."))
    console.log(numberRanges);

    var answers = [];
    console.log(q);
    for (let i = 0; i < 8; i++) {
      answers.push(GenerateRandom(parseInt(numberRanges[i][0]), parseInt(numberRanges[i][1])));
    }
    console.log(answers);

    var answerPlusID = [];
    for (let i = 0; i < 8; i++) {
      answerPlusID.push({
        number: answers[i],
        id: (5 + i)
      })
    }
    console.log(answerPlusID);
    var answerWanted = q.answer_1.split("|");
    answerWanted = answerWanted[1].split(".");
    console.log(answerWanted);

    var min = 0;
    var largest = 0;
    var smallest = 0;
    for (let i = 0; i < answerPlusID.length; i++) {
      //only add the appropriate ones
      if (answerPlusID[i].id == answerWanted[0]) {
        largest = (answerPlusID[i].number)
      } else if (answerPlusID[i].id == answerWanted[1]) {
        smallest = (answerPlusID[i].number)
      }
    }
    min = largest - smallest;
    console.log("The difference equals " + min);
    //this works
    correctAnswer = min;


    var answersUsed = [];
    answersUsed.push(correctAnswer);

    //randomise incorrect answers
    for (let i = 1; i < 4; i++) {
      var ans = GenerateUniqueRandom(1, 5, answersUsed)
      answersUsed.push(ans);
      questionAnswers.push({
        correct: false,
        value: ans,
        answerImage: ""
      });
    }


    //return matching value
    //use id instead???
    function ReturnMatchingValue(id) {
      //console.log(id);
      for (let i = 0; i < answerPlusID.length; i++) {
        if (answerPlusID[i].id == id) {
          //console.log(id + " matches with " + answerPlusID[i].id + " with a number of " + answerPlusID[i].number)
          return answerPlusID[i].number;
        }
      }
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //THIS IS FOR BAR GRAPH
    if (orderNumbers[0] == "Bar") {
      html = '<img src="' + Bar + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:137%'>" + "Zoo" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:134%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:134%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:134%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:134%'>" + "Giraffes" + "</b>";
      var rightPos = 76 + 55;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 5; i < 9; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:124%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(i) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers[0] == "Tally") {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:100%'>" + "Zoo" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:131.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:110.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:83.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:63%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57 + 55;
      var bigPosModifier = -22;
      for (let i = 5; i < 9; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }
    }

    //THIS IS FOR TABLE
    else {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:100%'>" + "Zoo" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:131.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:110.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:83.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:63%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82 + 55;
      var bigPosModifier = -22.2;
      for (let i = 5; i < 9; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }

    //then make graph on the right using the other values

    //THIS IS FOR BAR GRAPH
    if (orderNumbers2[0] == "Bar") {
      html += '<img src="' + Bar + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:27%'>" + "Safari" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:27%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:27%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:24%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:27%'>" + "Giraffes" + "</b>";
      var rightPos = 76 - 55;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 9; i < 13; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:14%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(i) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers2[0] == "Tally") {
      html += '<img src="' + Tally + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:-13%'>" + "Safari" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:21.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:0.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-27.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-47%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57 - 55;
      var bigPosModifier = -22;
      for (let i = 9; i < 13; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html += '<img src="' + Tally + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:-13%'>" + "Safari" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:21.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:0.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-27.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-47%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82 - 55;
      var bigPosModifier = -22.2;
      for (let i = 9; i < 13; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  if (q.topic_key == "Stat12") {
    //this is the order to which is correct
    var graphId = GenerateRandom(1, 4);
    var numbers = [];

    if (graphId == 1) {
      numbers.push(3);
      numbers.push(9);
      numbers.push(6);
      numbers.push(2);
    }
    else if (graphId == 2) {
      numbers.push(1);
      numbers.push(9);
      numbers.push(6);
      numbers.push(10);
    }
    else if (graphId == 3) {
      numbers.push(2);
      numbers.push(5);
      numbers.push(9);
      numbers.push(7);
    }
    else if (graphId == 4) {
      numbers.push(10);
      numbers.push(7);
      numbers.push(3);
      numbers.push(8);
    }
    else if (graphId == 5) {
      numbers.push(8);
      numbers.push(9);
      numbers.push(1);
      numbers.push(3);
    }
    console.log(q);
    console.log(temps);

    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];

    var usedNumbers = [];
    //get correct number
    var correctId;
    if (q.question.includes("lions")) {
      correctId = 1;
    }
    if (q.question.includes("zebras")) {
      correctId = 0;
    }
    if (q.question.includes("elephants")) {
      correctId = 2;
    }
    if (q.question.includes("giraffes")) {
      correctId = 3;
    }
    correctAnswer = numbers[correctId]
    //use the rest for incorrect

    answers.push(correctAnswer);
    for (let i = 0; i < 4; i++) {
      if (correctId != i)
        answers.push(numbers[i]);
    }

    questionAnswers.push({
      correct: false,
      value: answers[1],
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[2],
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[3],
      answerImage: ""
    });
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnPieChart() {
      if (graphId == 1)
        return Pie1;
      if (graphId == 2)
        return Pie2;
      if (graphId == 3)
        return Pie3;
      if (graphId == 4)
        return Pie4;
      if (graphId == 5)
        return Pie5;
    }

    html = '<img src="' + ReturnPieChart() + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }

  //A GREATER THAN B
  else if (q.topic_key == "Stat13") {

    function ReturnMean(input) {
      var total = 0;
      for (let i = 0; i < input.length; i++) {
        total += input[i];
      }
      return total / input.length;
    }

    function ScrambleArray(mean) {
      console.log(mean);
      var array = [];
      for (let i = 0; i < 4; i++) {
        array.push(mean);
      }
      //if decimal then add 1 to 2 random ones
      if (Number.isInteger(mean) == false) {
        for (let i = 0; i < 4; i++) {
          array[i] -= 0.5;
        }
        for (let i = 0; i < 2; i++) {
          array[GenerateRandom(0, 3)] += 1;
        }
      }
      console.log(array);
      console.log(mean * 4 / 4)
      //then scramble by add one minus one from other
      for (let i = 0; i < 7; i++) {
        //get random id
        let idUsed = [];
        let firstId = GenerateRandom(0, 3);
        idUsed.push(firstId);
        let secondId = GenerateUniqueRandom(0, 3, idUsed);
        if (array[secondId] > 1.5) {
          array[firstId] += 1;
          array[secondId] -= 1;
        }
      }
      console.log("scrambled");
      console.log(array);
      console.log(ReturnMean(array));
      return array;
    }

    correctAnswer = GenerateRandom(3, 6);
    if (Math.random() > 0.5)
      correctAnswer += 0.5;

    var numberLine = ScrambleArray(correctAnswer);

    //generate wrong answers
    var answersUsed = [];
    for (let i = 0; i < 3; i++) {
      var rand = GenerateUniqueRandom(1, 10, answersUsed);
      answersUsed.push(rand);
      if (Math.random() > 0.5)
        rand += 0.5;

      questionAnswers.push({
        correct: false,
        value: rand,
        answerImage: ""
      });
    }

    //show image

    html = '<img src="' + Sequence + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:100px ; color:white; position:absolute ; top:20% ; right:120%'>" + numberLine[0] + "</b>" +
      "<b style='font-size:100px ; color:white; position:absolute ; top:20% ; right:70%'>" + numberLine[1] + "</b>" +
      "<b style='font-size:100px ; color:white; position:absolute ; top:20% ; right:20%'>" + numberLine[2] + "</b>" +
      "<b style='font-size:100px ; color:white; position:absolute ; top:20% ; right:-30%'>" + numberLine[3] + "</b>";
  }


  questionAnswers.push({
    correct: true,
    value: correctAnswer,
    answerImage: correctAnswerImage
  });

  shuffleArray(questionAnswers);

  let question = {
    question: questionString,
    answers: questionAnswers,
    image: imageString,
    questionHTML: html,
    topic_id: q.topic_id
  }
  return question;
}




export default function Practice({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);
  const [levels, setLevels] = useState();

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);
  //Generates a question from a default question

  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 60;
  }
  
  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }
  //if question counter is higher than 3 then reset -refeed
  if(questionCounter > 3){
      questionCounter = 0;
  }

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  function RandomChar() {
    var result = '';
    var characters = 'abcdefghijklmnopqrstuvwxyz';
    var charactersLength = characters.length;
    result = characters.charAt(Math.floor(Math.random() * charactersLength));
    return result;
  }



  //Sets the question to a new one
  function newQuestion() {
        
        currQuestion = GenerateQuestion(questions[Math.floor(Math.random() * questions.length)]); 

        //Debugging
        /*
        console.log("tst: lastQ: " + lastQuestion);
        console.log("tst: currQ: " + currQuestion.question);
        console.log("tst: Counter: " + questionCounter);
        */

        //get refeed question
        var loop = true;
        var failSafeCounter = 0;
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
            repeating = true;
            questionCounter = 0;
            currQuestion = refeedQuestions[refeedQuestions.length - 1];
            loop = false;
        }
        else
        {
            //if current quesiton is same as the previous question then reloop -refeed 
         while(loop){
            if (currQuestion.question.toString() === lastQuestion.toString()) { 
                //console.log("tst: I have looped!");
                currQuestion = GenerateQuestion(questions[Math.floor(Math.random() * questions.length)]); 
                failSafeCounter = failSafeCounter + 1;
                if(failSafeCounter > 2){
                    lastQuestion = "";       
				}
            }
            else{
              // console.log("tst: Good to go!");
               loop = false; 
               break;
		    }
		 }   
        } 
        setCurrentQuestion(currQuestion);
        setRefresh(!refresh);
    }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

   //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
  function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
  }


  async function checkResult(value, callback) {
    console.log(value);

    //set the current question to the last question -refeed
    questionCounter = questionCounter +1;
    lastQuestion = currQuestion.question;

    var isCorrect = true;
    if (value.correct == true) {
      console.log(value.value + " " + currQuestion.correct);
      
      //correct answer
      setCorrectQuestions([...correctQuestions, currQuestion]);
      let multiplier = combo > 0 ? combo + 1 : 1;
      multiplier = multiplier > 5 ? 5 : multiplier;
      setScore(score + multiplier * 10);

      if (combo < 99) {
        setCombo(combo + 1);
      }
      if (combo > maxCombo) {
        setMaxCombo(combo);
      }
      //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
      if (repeating) {
         refeedQuestions.pop();
         repeating = false;
      }

      let qstring = currQuestion.question + " " + ( currQuestion.question2 !== undefined ? currQuestion.question2 : "")

        let result = {
          question: qstring,
          correct: currQuestion.correct,
          incorrect: value.value
      };
      setNoFeedback([...nofeedback, result]);
      
      newQuestion();
    }
    //incorrect answer
    else {
        isCorrect = false;
        questionCounter = 0;
      //push question to refeed if user gets it wrong - refeed
      refeedQuestions.push(currQuestion);

      setIncorrectQuestions([...incorrectQuestions, currQuestion]);
      if (combo === 0 && score >= 10) {
        setScore(score - 10);
      } else {
        setCombo(0);
      }

      let qstring = currQuestion.question + " " + ( currQuestion.question2 !== undefined ? currQuestion.question2 : "")

        let result = {
          question: qstring,
          correct: currQuestion.correct,
          incorrect: value.value
        };
      setFeedback([...feedback, result]);
      setColouredFeedback(true);
      setWaitTime(2);
    }

    //Generates a new question
    //newQuestion();
  }

  function MultipleButtons() {
    console.log(currentQuestion);

    return FilteredAnswers().map(answer => (

      <Button
        {...console.log(answer)}
        value={<div dangerouslySetInnerHTML={answer.value} />}
        style={{ flex: 1, margin: "20px" }}
        onClick={() => checkResult(answer, true)}
      >
        {answer.answerImage == "" ? (
          <div style={{ height: "80%", width: "100%" }}>
            <Textfit mode="multi" max="99" style={{ height: "100%" }}>
              {answer.value}
            </Textfit>
          </div>
        ) : (
            <ButtonImage src={require("../../assets/Measurements/Images/" + answer.answerImage)} ></ButtonImage>
          )
        }
      </Button>
    ))

  }

  function MultipleFeedbackButtons() {
    console.log(currentQuestion);

    return FilteredAnswers().map(answer => (

      <Button
        {...console.log(answer)}
        value={<div dangerouslySetInnerHTML={answer.value} />}
        style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
      >
        {answer.answerImage == "" ? (
          <div style={{ height: "80%", width: "100%" }}>
            <Textfit mode="multi" max="99" style={{ height: "100%" }}>
              {answer.value}
            </Textfit>
          </div>
        ) : (
            <ButtonImage src={require("../../assets/Measurements/Images/" + answer.answerImage)} ></ButtonImage>
          )
        }
      </Button>
    ))

  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if (waitTime != -10){

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);


  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = GenerateQuestion(questions[Math.floor(Math.random() * questions.length)]);
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
    }
  }, [status]);

  function FilteredAnswers() {
    if (currentQuestion.answers != undefined) {
      return currentQuestion.answers.filter(v => v.value !== "");
    }
    return currentQuestion;
  }

  if ((currentQuestion.image != "" && currentQuestion.image != undefined)) {
    qImage = require('../../assets/Measurements/Images/' + currentQuestion.image);
  }

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = props.gameData.animation_path + "/combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/"+imageName)
        return (require("../../assets/"+imageName))
}

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionLimit={questionMax}
        onBack={() =>{
        Reset();
        props.onBack();
        }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
          Reset();
        }}
      >
        <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={1720}>
            <Body>
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <Question
                        type="text"
                        disabled
                        value={
                          currentQuestion.question !== undefined
                            ? currentQuestion.question.replace("$", "?")
                            : ""
                        }
                      ><Textfit mode="single" style={{ height: "100%" }}>

                          {currQuestion.question}
                        </Textfit>
                      </Question>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
                      {(currentQuestion.image != "" && currentQuestion.image != undefined) && currentQuestion.questionHTML == "" ? (
                        <img src={qImage}></img>
                        /*<img src = {image} className ={style.geoImg} filter = {hue-rotate(60deg);}></img>*/
                      ) : (
                          <div></div>
                        )}
                      {currentQuestion.questionHTML != "" ? (
                        //<div dangerouslySetInnerHTML={{__html: currentQuestion.questionHTML}}></div>
                        //<div><img src={require("../assets/Measurements/Images/LiftSign.png")}></img></div>
                        //<div innerHtml={currentQuestion.questionHTML}></div>
                        <DynamicStyle>
                          <div dangerouslySetInnerHTML={{ __html: currentQuestion.questionHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                      }}
                    >
                      {showColouredFeedback == false && currQuestion.answers !== undefined &&
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {MultipleButtons()}
                        </div>}

                        {showColouredFeedback == true && currQuestion.answers !== undefined &&
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {MultipleFeedbackButtons()}
                        </div>}
                    </div>
                  </Container>

                ) : <h1>blank</h1>}
              </div>
              <Combo>
                <span style={{ fontSize: "50px" }}>{combo}</span>
                <span style={{ fontSize: "20px" }}>COMBO</span>
              </Combo>
            </Body>
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("${props => props.gameBackground}");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 90%;
padding-top: 15px;
`

const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;
